// extracted by mini-css-extract-plugin
module.exports = {"groupTitle":"SearchFormLabel_groupTitle___O2H8","hidden":"SearchFormLabel_hidden__dQpm5"};